import axiosInstance from "../config/API";

const API_ENDPOINT = "/expense.php";

const getCreatedById = () => {
  const userId = sessionStorage.getItem("userid");

  if (!userId) {
    throw new Error("User not logged in. Please log in to continue.");
  }

  return userId;
};

// Fetch all expenses
export const fetchExpensesApi = async (searchText = "") => {
  const created_by_id = getCreatedById();
  const payload = {
    action: "listExpenses",
    search_text: searchText,
    created_by_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  const { head, body } = response.data;
  console.log(response.data);
  if (head.code !== 200) {
    throw new Error(head.msg || "Failed to fetch expenses");
  }

  return body.Expenses;
};

// Add a new expense
export const addExpenseApi = async (expenseData) => {
  const created_by_id = getCreatedById();
  const payload = {
    action: "addExpense",
    expense_date: expenseData.expense_date,
    expense_data: expenseData.expense_data,
    created_by_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  const { head, body } = response.data;
  console.log(response.data);

  if (head.code !== 200) {
    throw new Error(head.msg || "Failed to create expense");
  }

  return body.Expenses[0];
};

// Update an expense
export const updateExpenseApi = async (expenseData) => {
  const created_by_id = getCreatedById();
  const payload = {
    action: "updateExpense",
    expense_id: expenseData.expense_id,
    expense_date: expenseData.expense_date,
    expense_data: expenseData.expense_data,
    created_by_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  const { head } = response.data;

  if (head.code !== 200) {
    throw new Error(head.msg || "Failed to update expense");
  }

  return { expense_id: head.expense_id, ...expenseData };
};

// Delete an expense
export const deleteExpenseApi = async (expenseId) => {
  const created_by_id = getCreatedById();
  const payload = {
    action: "deleteExpense",
    delete_expense_id: expenseId,
    created_by_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  const { head } = response.data;

  if (head.code !== 200) {
    throw new Error(head.msg || "Failed to delete expense");
  }

  return expenseId;
};
